import classed from "classed-components"

export const Container = classed.div(["container", "mx-auto", "w-100"])


export const Background = classed.div('bg-gradient-to-br from-indigo-500 bg-calm h-full')
